<template>
  <v-container fluid>
    <v-row>
      <v-col cols="12">
        <v-data-table
        :items="payables"
        dense
        :headers="headers"
        fixed-header
        :height="tableHeight"
        :footer-props="footerProps"
        @update:items-per-page="itemsPerPageUpdated"
        :items-per-page="dataTableDefaultItemsPerPage"
        >
          <template #[`item.amount`]="{item}">
            {{formatMoney(item.amount)}}
          </template>
          <template #[`item.createdAt`]="{item}">
            {{utcToLocalDate(item.createdAt)}}
          </template>
          <template #[`item.payDate`]="{item}">
            {{utcToLocalDate(item.payDate)}}
          </template>
        </v-data-table>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import TractHeaders from '@/headers/Tract.js'
import { formatMoney } from '@/utils/NumericMutations'
import { utcToLocalDate } from '@/utils/DateFormatter.js'
import { dataTableItemsPerPage, tableHeight, dataTableDefaultItemsPerPage } from '@/utils/componentHelpers'

export default {
  name: 'CurrentMiscFinancials',

  props: {
    payables: {
      type: Array
    }
  },

  data: () => ({
    dataTableDefaultItemsPerPage,
    currentItemsPerPage: dataTableDefaultItemsPerPage
  }),

  computed: {
    headers () {
      return TractHeaders.currentTractPayableHeaders().filter(h => h.text !== this.$t('actions') && (this.includeTract || h.text !== this.$t('tractName')))
    },

    includeTract () {
      return this.payables.some(p => p.tractName !== undefined)
    },

    footerProps () {
      return { 'items-per-page-options': dataTableItemsPerPage }
    },

    tableHeight () {
      const currIpp = this.currentItemsPerPage > 0 ? this.currentItemsPerPage : Number.MAX_SAFE_INTEGER
      const dataLength = Math.min(this.payables.length, currIpp)
      return tableHeight({
        dataLength,
        absoluteMinimum: 64,
        absoluteMaximum: 800,
        offset: 500,
        headersLength: this.headers.length
      })
    }
  },

  methods: {
    formatMoney,
    utcToLocalDate,

    itemsPerPageUpdated (val) {
      this.currentItemsPerPage = val
    }
  }
}
</script>
